module.exports = __webpack_public_path__ + "img/nota_folio.1f4370ec.png";